/**  React libraries */
import { Col, Container, Row } from "react-bootstrap";

/** Component, Utility, Types, Constant */
import { DEFAULT_ERROR_MSG } from "../../utils/constants";

/** Styles */
import "./errorPage.style.css";

const ErrorPage = () => {
  return (
    <>
      <main className="container-fluid errorPage-bg">
         <Container fluid className="vh-100 d-flex justify-content-center align-items-center">
            <Row>
                <Col className="text-center">
                   <h2>{DEFAULT_ERROR_MSG}</h2>
                </Col>
            </Row>
        </Container>
      </main>
    </>
  );
};

export default ErrorPage;
